
























import { defineComponent, PropType } from '@nuxtjs/composition-api'
import MainPriceText from '~/components/car/classifieds/view/partials/Price/MainPriceText.vue'
import { ClassifiedPayment, ClassifiedSalary } from '~/models/classified/types'

export default defineComponent({
  components: { MainPriceText },
  props: {
    payment: {
      type: Object as PropType<ClassifiedPayment>,
      default: null
    },
    salary: {
      type: Object as PropType<ClassifiedSalary>,
      default: null
    }
  }
})
